import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'http://192.168.2.25:3000';

// Mapeo de frases según el número de código_evento (1 a 12)
const EVENTOS_MAP = {
    1: "Encendido",
    2: "Fin de marcacion TempSet @ TimeSet",
    3: "Fin de test de pureza: Baja Actividad",
    4: "Fin de test de pureza: Saturación por exceso de actividad",
    5: "Fin de test de pureza: ok (mayor a 90%)",
    6: "Fin de test de pureza: falló (menor a 90%)",
    7: "Fin de test de Molibdeno: no se detecto molibdeno en la muestra",
    8: "Fin de test de Molibdeno: se detecto molibdeno en la muestra",
    9: "Reposo",
    10: "Error en el horno",
    11: "Alarma de alto fondo",
    12: "Modo servicio",
    13: "Proceso cancelado",
    14: "Inicio de marcacion: SESTAMIBI",
    15: "Inicio de marcacion: NEUROBAC",
    16: "Inicio de marcacion: OSTEOBAC",
    17: "Inicio de marcacion: PROGRAMA DE USUARIO",
    18: 'Test pureza',
    19: 'Test moli'
};

function TestMonitor() {
    const [registros, setRegistros] = useState([]);
    const [ultimo, setUltimo] = useState(null);
    const [estado, setEstado] = useState('conectando');

    const getHeaders = () => {
        const token = localStorage.getItem('token');
        return { headers: { Authorization: `Bearer ${token}` } };
    };

    const traerDatos = async () => {
        try {
            const res = await axios.get(`${API}/api/datos-medicos`, getHeaders());
            // QUITAMOS EL SLICE para que muestre TODO lo que viene de la DB
            setRegistros(Array.isArray(res.data) ? res.data : []);
            setUltimo(new Date());
            setEstado('ok');
        } catch (err) {
            console.error("Error capturando datos:", err);
            setEstado('error');
        }
    };

    useEffect(() => {
        traerDatos();
        const interval = setInterval(traerDatos, 3000);
        return () => clearInterval(interval);
    }, []);

    const val = (v, suffix = '') => (v !== null && v !== undefined) ? `${v}${suffix}` : '—';
    const getEventoTexto = (cod) => EVENTOS_MAP[cod] || `Evento ${cod}`;

    return (
        <div style={styles.pagina}>
            <div style={styles.wrap}>

                <div style={styles.header}>
                    <span style={styles.titulo}>BAC MT — Monitor Completo (Total: {registros.length})</span>
                    <div style={styles.headerDer}>
                        {ultimo && <span style={styles.actTime}>ACT: {ultimo.toLocaleTimeString()}</span>}
                        <span style={{ ...styles.badge, ...(estado === 'ok' ? styles.badgeOk : styles.badgeErr) }}>
                            <span style={{ ...styles.dot, backgroundColor: estado === 'ok' ? '#10c48a' : '#f04d5e' }} />
                            {estado === 'ok' ? 'RECIBIENDO' : 'ERROR'}
                        </span>
                    </div>
                </div>

                {/* CONTENEDOR CON SCROLL PARA VER TODOOO */}
                <div style={styles.scrollContainer}>
                    <table style={styles.tabla}>
                        <thead style={styles.theadSticky}>
                            <tr>
                                {[
                                    '#', 'ID DB', 'DISP', 'EQUIPO', 'WIFI', 'ARD', 'PANT', 
                                    'MODO', 'EVENTO', 'T.SET', 'TIME.S', 'TEMP.R', 'C.PUR', 
                                    'C.FO', 'C.FA', 'PUREZA %', 'MOLI', 'FECHA'
                                ].map(h => (
                                    <th key={h} style={styles.th}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {registros.length === 0 ? (
                                <tr><td colSpan="18" style={styles.tdVacio}>No hay datos disponibles.</td></tr>
                            ) : (
                                registros.map((reg, i) => (
                                    <tr key={reg.id} style={i === 0 ? styles.trNuevo : styles.trNormal}>
                                        <td style={styles.tdN}>{i + 1}</td>
                                        <td style={styles.tdM}>#{reg.id}</td>
                                        <td style={styles.tdM}>{reg.dispositivo_id}</td>
                                        <td style={styles.tdM}>{reg.id_equipo}</td>
                                        <td style={styles.tdM}>{reg.firm_wifi}</td>
                                        <td style={styles.tdM}>{reg.firm_ard}</td>
                                        <td style={styles.tdM}>{reg.firm_pantalla}</td>
                                        <td style={styles.tdM}>{reg.tiempo_real === 1 ? 'REAL' : 'MEM'}</td>
                                        <td style={{ ...styles.tdM, color: '#facc15' }}>{getEventoTexto(reg.codigo_evento)}</td>
                                        <td style={styles.tdM}>{val(reg.temp_set, '°')}</td>
                                        <td style={styles.tdM}>{val(reg.time_set, 'm')}</td>
                                        <td style={{ ...styles.tdM, color: '#00c2d4', fontWeight: 'bold' }}>{val(reg.temp_real, '°')}</td>
                                        <td style={styles.tdM}>{val(reg.cod_pureza)}</td>
                                        <td style={styles.tdM}>{reg.cuentas_fo?.toLocaleString()}</td>
                                        <td style={styles.tdM}>{reg.cuentas_fa?.toLocaleString()}</td>
                                        <td style={{ ...styles.tdM, color: '#10c48a', fontWeight: 'bold' }}>{val(reg.valor_pureza, '%')}</td>
                                        <td style={styles.tdM}>{val(reg.cod_moli)}</td>
                                        <td style={styles.tdFecha}>{new Date(reg.fecha).toLocaleString()}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

const styles = {
    pagina: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#020617', padding: '10px' },
    wrap: { backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '8px', overflow: 'hidden', width: '100%', maxWidth: '1600px' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#0f172a' },
    
    // ESTA ES LA BARRITA DE SCROLL
    scrollContainer: { 
        maxHeight: '700px', // Altura máxima antes de mostrar scroll vertical
        overflowY: 'auto',   // Scroll vertical
        overflowX: 'auto',   // Scroll horizontal si la tabla es muy ancha
        backgroundColor: '#0f172a' 
    },

    theadSticky: { position: 'sticky', top: 0, zIndex: 10 }, // Mantiene los títulos arriba al scrollear
    titulo: { fontSize: '0.75rem', fontWeight: '700', color: '#f1f5f9' },
    headerDer: { display: 'flex', alignItems: 'center', gap: '12px' },
    actTime: { fontSize: '0.65rem', color: '#64748b', fontFamily: 'monospace' },
    badge: { display: 'flex', alignItems: 'center', gap: '6px', padding: '4px 10px', borderRadius: '4px', fontSize: '0.6rem', fontWeight: '800' },
    badgeOk: { backgroundColor: 'rgba(16,196,138,0.1)', color: '#10c48a' },
    badgeErr: { backgroundColor: 'rgba(240,77,94,0.1)', color: '#f04d5e' },
    dot: { width: '6px', height: '6px', borderRadius: '50%' },
    tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '0.65rem' },
    th: { padding: '12px 8px', textAlign: 'left', color: '#94a3b8', backgroundColor: '#020617', borderBottom: '2px solid #334155', whiteSpace: 'nowrap' },
    trNormal: { borderBottom: '1px solid #334155' },
    trNuevo: { backgroundColor: 'rgba(56,189,248,0.15)', borderBottom: '1px solid #0ea5e9' },
    tdN: { padding: '8px', color: '#475569', textAlign: 'center' },
    tdM: { padding: '8px', color: '#cbd5e1', fontFamily: 'monospace', whiteSpace: 'nowrap' },
    tdFecha: { padding: '8px', color: '#64748b', fontSize: '0.65rem', whiteSpace: 'nowrap' },
    tdVacio: { padding: '60px', textAlign: 'center', color: '#64748b' }
};

export default TestMonitor;